import { render, staticRenderFns } from "./PublicNewsDetails.vue?vue&type=template&id=4689963c&scoped=true"
import script from "./PublicNewsDetails.vue?vue&type=script&lang=js"
export * from "./PublicNewsDetails.vue?vue&type=script&lang=js"
import style0 from "./PublicNewsDetails.vue?vue&type=style&index=0&id=4689963c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689963c",
  null
  
)

export default component.exports